










import Vue from "vue";
import Component from "vue-class-component";
import { CentralNotificacoesService } from "@/services/central-notificacao.service";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: number;
}

@Component
export default class ComboTipoNotificacao extends Vue {
  valid = false;
  tipo: ComboItem | null = null;
  itemsTipo: ComboItem[] = [];
  loading = false;

  @Prop(Number) readonly value!: number | undefined;
  @Prop() readonly rules!: unknown;

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  async fetchTipos() {
    this.loading = true;
    const res = await CentralNotificacoesService.listarTiposNotificacao();
    this.itemsTipo = res.map((x) => ({
      text: x.nome,
      value: x.idTipoNotificacao,
    }));

    if (this.value) {
      this.tipo = this.itemsTipo.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchTipos();
  }
}
